export default __webpack_public_path__ + "static/thumbnail_oil-7811c3420bf9fb5fa47353038220b7d4.jpg";